export enum TimeInterval {
    YEAR = "year",
    MONTH = "month",
    WEEK = "week",
    DAY = "day",
  }
  